import { useThemeVersion } from '@raisin/components-lib';
import React from 'react';
import CountryPickerV1 from './v1';
import CountryPickerV2 from './v2';
export const CountryPicker = (props) => {
    const version = useThemeVersion();
    if (version === 'v2') {
        return React.createElement(CountryPickerV2, Object.assign({}, props));
    }
    return React.createElement(CountryPickerV1, Object.assign({}, props));
};
//# sourceMappingURL=CountryPicker.js.map